import Floor from '../../Entities/Buildings/Floor';
import GenericNamespaceHandler from '../../GenericNamespaceHandler'; // eslint-disable-line import/no-cycle

export default class FloorsNamespace extends GenericNamespaceHandler {
  namespace = 'buildings/floors';

  searchCall = '';

  createCall = 'create';

  updateCall = 'update';

  updateMultipleCall = 'updateMultiple';

  deleteCall = 'delete';

  searchRequiresBuildingId = true;

  responseEntity = Floor;

  responseKey = 'floor';

  requiredFields = [
    {
      param: 'building_id',
      requiredForCreate: true,
      requiredForUpdate: false,
      error: 'provide_building_id',
      validation: { type: 'int' }
    },
    {
      param: 'name',
      requiredForCreate: true,
      requiredForUpdate: false,
      error: 'invalid_floor_name',
      validation: { type: 'string', min: 3, max: 255 }
    },
    {
      param: 'enabled',
      requiredForCreate: false,
      requiredForUpdate: false,
      validation: { type: 'bool' }
    },
    {
      param: 'seq',
      requiredForCreate: false,
      requiredForUpdate: false,
      validation: { type: 'int', error: 'invalid_seq' }
    }
  ];

  searchByBuildingId(
    buildingId,
    criteria = {},
    page = 1,
    orderBy,
    orderDirection
  ) {
    const crit = criteria;
    if (buildingId) crit.building_id = buildingId;
    return this.search(crit, page, orderBy, orderDirection);
  }

  create(buildingId = null, name = '', seq = undefined) {
    const data = { building_id: buildingId, name, seq, enabled: true };
    return super.create(data);
  }

  update(id = null, optional = { name: undefined, seq: undefined }) {
    return super.update(id, optional);
  }
}
